import Cookies from 'universal-cookie';

const cookies = new Cookies();

/**
 * Get cookie.
 *
 * @param key : whose value to get.
 */
export function get(key: string): string | number | boolean | null | undefined {
  return cookies.get(key);
}

/**
 * Set cookie.
 *
 * @param key : whose Value to set.
 * @param value : Value to set.
 */
export function set(
  key: string,
  value: string | number | boolean | Record<string, string | number | boolean | null>
): void {
  cookies.set(key, value, {
    path: '/',
  });
}

/**
 * Remove key value pair in storage.
 *
 * @param key
 */
export function remove(key: string): void {
  cookies.remove(key);
}
